import { ChangeEventHandler, FC, FormEventHandler, KeyboardEventHandler, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SendIcon from '../../assets/icons/send-icon.svg?react';
import { ChatInput } from '../../components/assistant/chat/chat-input';
import { Button } from '../../components/buttons';
import { useSendMessageMutation } from '../../services/assistant';
import { SEND_MESSAGE_RTK_KEY } from './constants';

type AssistantInputProps = {
  handleSendMessage: (question: string) => Promise<void>;
  isLoading?: boolean;
};

export const AssistantInput: FC<AssistantInputProps> = ({ handleSendMessage, isLoading }) => {
  const { t } = useTranslation('assistant');
  const [question, setQuestion] = useState('');

  const [_, { isLoading: isMessageSending }] = useSendMessageMutation({ fixedCacheKey: SEND_MESSAGE_RTK_KEY });

  const handleChangeInput: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setQuestion(e.target.value);
  };

  const onKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (isMessageSending || !question) return;

      onSubmit(e as unknown as React.FormEvent<HTMLFormElement>);
    }
  };

  const onSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    await handleSendMessage(question);
    setQuestion('');
  };

  return (
    <form onSubmit={onSubmit} className='grid grid-cols-[1fr,fit-content(100%)] items-center gap-x-3 border rounded-lg px-4 py-3'>
      <ChatInput
        placeholder={t('writeMessageHere')}
        onChange={handleChangeInput}
        onKeyDown={onKeyDown}
        value={question}
        disabled={isLoading || isMessageSending}
        maxLength={1000}
      />
      <Button className='right-5 top-1/4 flex size-8 !p-2 rounded-lg self-end' type='submit' disabled={isLoading || !question}>
        <SendIcon />
      </Button>
    </form>
  );
};
